<template>
  <router-view/>
</template>

<script>
export default {
    name: 'app',
    watch: {
        '$route' () {
            document.title=this.$route.meta.title;
        }
    },
    mounted(){
        document.title=this.$route.meta.title;

    },
}
</script>

<style>

</style>
